import React, { HTMLAttributes, PropsWithoutRef } from "react";

import classNames from "classnames";

import { StyledToolbar } from "./Toolbar.styles";
import { Portal } from "../../helpers";

export interface ToolbarProps extends HTMLAttributes<HTMLDivElement> {
  open: boolean;
  renderInPortal?: boolean;
}

export function Toolbar({
  open = false,
  renderInPortal = true,
  children,
  className,
  style,
}: PropsWithoutRef<ToolbarProps>) {
  // Abstract content with default values.
  const TOOLBAR_CONTENT = (
    <StyledToolbar
      className={classNames("c-toolbar", className)}
      role="toolbar"
      tabIndex={-1}
      aria-orientation="horizontal"
      aria-modal="true"
      style={style}
    >
      {children}
    </StyledToolbar>
  );

  // If `renderInPortal` prop is present, render toolbar content in Portal.
  // default: true
  if (renderInPortal) open ? <Portal>{TOOLBAR_CONTENT}</Portal> : null;

  return open ? TOOLBAR_CONTENT : null;
}

Toolbar.displayName = "Toolbar";
